import { render } from "./DigitalTransformation.vue?vue&type=template&id=7a8cd466"
import script from "./DigitalTransformation.vue?vue&type=script&lang=js"
export * from "./DigitalTransformation.vue?vue&type=script&lang=js"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__